import { render, staticRenderFns } from "./increase-products.vue?vue&type=template&id=46f6ba23&scoped=true&"
import script from "./increase-products.vue?vue&type=script&lang=js&"
export * from "./increase-products.vue?vue&type=script&lang=js&"
import style0 from "./increase-products.vue?vue&type=style&index=0&id=46f6ba23&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f6ba23",
  null
  
)

export default component.exports